import { gsap } from 'gsap';

function shouldReduceMotion() {
  if (document.documentElement.classList.contains('is-no-motion')) return true;

  return window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)')
    .matches;
}

function getVisualTarget(card, visualSelector) {
  if (!visualSelector) return card;

  return card.querySelector(visualSelector) ?? card;
}

function revealCardImmediately(card, options = {}) {
  const visualTarget = getVisualTarget(card, options.visualSelector);

  gsap.set(card, {
    y: 0,
    scale: 1,
  });

  gsap.set(visualTarget, {
    opacity: 1,
    filter: 'blur(0px)',
  });
}

function animateCard(card, delay, options = {}) {
  const {
    opacityEase = 'power1.out',
    revealDuration = 0.5,
    settleDuration = 0.3,
    revealEase = 'power1.out',
    visualSelector,
  } = options;
  const visualTarget = getVisualTarget(card, visualSelector);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: card,
      start: 'top 75%',
      toggleActions: 'play none none none',
    },
  });

  tl.to(
    visualTarget,
    {
      opacity: 1,
      duration: revealDuration,
      ease: opacityEase,
    },
    delay,
  )
    .to(
      card,
      {
        y: 0,
        scale: 1.02,
        duration: revealDuration,
        ease: revealEase,
      },
      delay,
    )
    .to(
      visualTarget,
      {
        filter: 'blur(0px)',
        duration: revealDuration,
        ease: revealEase,
      },
      delay,
    )
    .to(card, {
      scale: 1,
      duration: settleDuration,
      ease: 'power1.inOut',
    });
}

function initCardGroup(parent, cardSelector, options) {
  if (!parent || parent.dataset.wllCardsAnimated === 'true') return;

  const cards = parent.querySelectorAll(cardSelector);
  if (!cards.length) return;

  parent.dataset.wllCardsAnimated = 'true';

  if (shouldReduceMotion()) {
    cards.forEach((card) => revealCardImmediately(card, options));
    return;
  }

  cards.forEach((card, index) => {
    animateCard(card, index * 0.1, options);
  });
}

export function initAllWllCards() {
  document.querySelectorAll('.wll-questions').forEach((section) => {
    initCardGroup(section, '.wll-info-card', {
      visualSelector: '.wll-info-card__panel',
    });
  });

  document.querySelectorAll('.wll-process').forEach((section) => {
    initCardGroup(section, '.wll-process-card');
  });

  document.querySelectorAll('.wll-reviews').forEach((section) => {
    initCardGroup(section, '.wll-review-card');
  });
}
